<div class="min-h-full flex flex-col items-center justify-center p-6 lg:p-12">
  
  <div class="w-full max-w-6xl mx-auto flex flex-col items-center text-center">
    
    <header class="mb-12 flex flex-col gap-4 animate-fade-in-up">
      <h1 class="text-4xl lg:text-5xl font-extrabold text-heading tracking-tight">
        {{ config.texts.pageTitle }}
      </h1>
      <p class="text-lg lg:text-xl text-secondary-text max-w-2xl mx-auto">
        {{ config.texts.pageSubtitle }}
      </p>
    </header>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 w-full mb-12">
      @for (option of startOptions(); track option.id) {
        
        <button (click)="selectOption(option.id)"
                [disabled]="isNavigating()"
                class="group relative flex flex-col text-left bg-component-inner border rounded-2xl p-6 lg:p-8 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-focus-ring cursor-pointer"
                [ngClass]="{
                  'border-primary shadow-default': option.recommended,
                  'border-primary-border hover:border-secondary-border hover:shadow-default': !option.recommended
                }"
                style="transform: translateZ(0); /* Hardware acceleration for hover */">
          
          <div class="absolute inset-0 rounded-2xl bg-hover-default opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>

          @if (option.recommended) {
            <div class="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary text-primary-button-text text-xs font-bold px-3 py-1 rounded-full shadow-sm">
              {{ config.texts.recommendedBadge }}
            </div>
          }

          <div class="w-14 h-14 rounded-xl flex items-center justify-center bg-alt-background border border-secondary-border mb-6 group-hover:scale-105 transition-transform duration-300 shadow-sm relative z-10">
            <i [class]="option.iconClass + ' text-2xl ' + (option.recommended ? 'text-primary' : 'text-primary-text')"></i>
          </div>

          <h2 class="text-2xl font-bold text-heading mb-3 relative z-10">
            {{ option.title }}
          </h2>
          
          <p class="text-secondary-text mb-6 min-h-[4rem] relative z-10">
            {{ option.description }}
          </p>

          <ul class="flex flex-col gap-3 mb-8 flex-1 relative z-10">
            @for (bullet of option.bullets; track bullet) {
              <li class="flex items-start text-sm text-primary-text">
                <i class="fas fa-check text-success mt-1 mr-3 shrink-0"></i>
                <span>{{ bullet }}</span>
              </li>
            }
          </ul>

          <div class="w-full mt-auto relative z-10">
            <div class="w-full text-center font-semibold rounded-lg px-6 py-3 transition-colors duration-200"
                 [ngClass]="{
                   'bg-primary text-primary-button-text': option.recommended,
                   'bg-button-bg text-secondary-button-text border border-secondary-border group-hover:bg-primary group-hover:text-primary-button-text group-hover:border-primary': !option.recommended
                 }">
              {{ option.ctaLabel }}
            </div>
          </div>

        </button>
      }
    </div>

    <footer class="mt-4 flex items-center gap-3 text-secondary-text animate-fade-in-up">
      <i class="fad fa-info-circle text-lg"></i>
      <span class="text-sm font-medium">{{ config.texts.footerNote }}</span>
    </footer>

  </div>
</div>